import { render } from "./TicketReservationList.vue?vue&type=template&id=2fa1b8ba&scoped=true"
import script from "./TicketReservationList.vue?vue&type=script&lang=js"
export * from "./TicketReservationList.vue?vue&type=script&lang=js"

import "./TicketReservationList.vue?vue&type=style&index=0&id=2fa1b8ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa1b8ba"]])

export default __exports__